'use client';

import { useState } from 'react';
import { InquiryForm } from './InquiryForm';

interface BookingTabsProps {
  programOptions: string[];
}

const TABS = [
  {
    key: 'CONSULTATION' as const,
    label: 'Book a consultation',
    intro:
      'A free 20-minute call about your goal, your level, and the right program. No obligation.',
    submitLabel: 'Request my free consultation',
    messageLabel: 'What do you want to achieve with English?',
    messagePlaceholder: 'For example: “I have a job interview in English next month.”',
  },
  {
    key: 'PLACEMENT_TEST' as const,
    label: 'Request a placement test',
    intro:
      'A short, friendly assessment of your real speaking level — so you start in the right group, not too easy and not too hard.',
    submitLabel: 'Request my placement test',
    messageLabel: 'Tell us briefly about your English background',
    messagePlaceholder: 'For example: “I studied English in school but rarely speak it.”',
  },
];

/** Tabbed booking flow: consultation call or placement test. */
export function BookingTabs({ programOptions }: BookingTabsProps) {
  const [active, setActive] = useState<(typeof TABS)[number]>(TABS[0]!);

  return (
    <div>
      <div role="tablist" aria-label="Booking type" className="vn-taglist" style={{ marginBottom: 'var(--space-5)' }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            role="tab"
            type="button"
            aria-selected={active.key === tab.key}
            className={`vn-btn vn-btn--small ${active.key === tab.key ? 'vn-btn--primary' : 'vn-btn--secondary'}`}
            onClick={() => setActive(tab)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <p className="vn-lede">{active.intro}</p>
      <InquiryForm
        key={active.key}
        fixedType={active.key}
        programOptions={programOptions}
        submitLabel={active.submitLabel}
        messageLabel={active.messageLabel}
        messagePlaceholder={active.messagePlaceholder}
      />
    </div>
  );
}
